import { render, staticRenderFns } from "./schoolManage.vue?vue&type=template&id=2e4736ee&scoped=true&"
import script from "./schoolManage.vue?vue&type=script&lang=ts&"
export * from "./schoolManage.vue?vue&type=script&lang=ts&"
import style0 from "./schoolManage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./schoolManage.vue?vue&type=style&index=1&id=2e4736ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4736ee",
  null
  
)

export default component.exports